<template>
  <!-- The native picker speaks YYYY-MM-DD and shows the user's locale (DD.MM.YYYY here). -->
  <input class="field__control field__control--date"
    type="date"
    :value="modelValue || ''"
    @input="$emit('update:modelValue', $event.target.value || '')">
</template>

<script>
export default {
  name: 'date-input',
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: String, default: '' },
  },
}
</script>
